import React, { useContext, useState } from 'react';
import OtpInput from 'react-otp-input';
import { IoCloseSharp } from 'react-icons/io5';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { PropsFromRedux } from '.';
import { BeatLoader } from '../Spinners/Spinner';
import { API_KEYS } from '../../interfaces/api';
import TextInput from '../form-controls/TextInput';
import OutboundShipmentContext from '../../context/OutboundShipmentContext/OutboundShipmentContext';



interface Props extends PropsFromRedux {}

const CouponModal: React.FC<Props> = ({ 
   hideModal,
   showModal,
   modal,
   resetApi,
   getCoupon,
   getCouponState
 }) => {

    const [coupon, setCoupon] = useState('');
    const  { outboundData, setOutboundData} = useContext(OutboundShipmentContext);

    interface Inputs {
        Coupon: string;
    }

    const schema = yup.object().shape({
        Coupon: yup.string().required(),
    })

    const closeModal = () => {
        hideModal();
    };

    React.useEffect(() => {
      if(getCouponState?.success){
        const saveData = outboundData;
        saveData.IsCoupon = true;
        setOutboundData(saveData);
        hideModal();
      }
  },[getCouponState?.success]);



    const onSubmit = async (data: Inputs) => {
        const saveData = outboundData;
        const amount = saveData.PriceDetails.GrandTotal;
        const newamount = Math.round(amount);
        getCoupon(data.Coupon, newamount);
    }

    const { handleSubmit, control, errors, reset, watch, setValue } = useForm<Inputs>({
        resolver: yupResolver(schema),
  });

    return(
        <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
        <div className="w-full px-2 bg-white lg:px-24 py-10 relative">
           <button type="button" aria-label="Close" onClick={closeModal}>
            <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
          </button>
         <div className="w-full my-2 text-center">
             <h5 className="mb-1 text-md font-bold text-black">Redeem Coupon</h5>
          </div>
          <div className="w-full mt-12 mb-6 text-sm">
          <div className="mb-2 text-sm text-gray-500 font-medium">
          <Controller
            name="Coupon"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-3 w-full rounded"
                id={name}
                labelClassName="mb-2 text-xs flex"
                label="Coupon code:"
                type="text"
                wrapperClassName="w-full"
                error={errors['Coupon']}
                placeholder="Enter coupon code"
                customChange={onChange}
              />
            )}
          />
        </div>
          </div>
            <button className="w-full bg-green-400 font-medium text-sm rounded-sm text-white py-2" type="submit"
             disabled={getCouponState?.loading}>
            {getCouponState?.loading ? <BeatLoader color="white" /> : 'Apply'}
            </button>
      </div>
      </form>
      );
    };
    
    export default CouponModal;